import { Component, OnInit, Input } from '@angular/core';

import { ConfigureService } from '@app/configure/services/configure.service';
import { ModalService } from '@app/core/services/modal.service';

import { Modal } from '@app/core/models/modal.model';

@Component({
	selector: 'cng-callback-modal',
	templateUrl: './callback.component.html',
	styleUrls: ['./callback.component.less'],
})
export class ConfigureCallbackModalComponent implements OnInit {
	constructor(private modal_service: ModalService, private configure_service: ConfigureService) {
		this.constructModal();
	}

	constructModal(): void {
		this.modal_service.setConfig(
			new Modal({
				name: 'callback_modal',
				title: 'Callback Request',
				height: 'full',
			})
		);
	}

	ngOnInit(): void {
		this.configure_service.track('modal.open', { modal: 'callback' }).subscribe();
	}

	onCallbackCreated(): void {
		this.modal_service.close();
	}
}
